<ag-grid-angular style="width: 100%; height: 220px"
 class="ag-theme-alpine-thin" [gridOptions]="gridOptions"
    [columnDefs]="columnDefs">
</ag-grid-angular>